/**
 *
 * ShellAvatar
 *
 */
import classNames from 'classnames';
import Icon from '@react/react-spectrum/Icon';
import React, { forwardRef } from 'react';
import './ShellAvatar.scss';
interface Props {
  large?: boolean;
  src?: string;
  className?: string;
}
interface Props {}

export const ShellAvatar = forwardRef<HTMLElement, Props>(function ShellAvatar(
  { className, large, src }: Props,
  ref
) {
  const [imageError, setImageError] = React.useState(false);
  return (
    <figure
      className={classNames('spectrum-Shell-avatar', className, {
        'spectrum-Shell-avatar--large': large
      })}
      ref={ref}
    >
      {!src || imageError ? (
        <Icon size="M">
          <svg viewBox="0 0 64 64" x="0px" y="0px">
            <g>
              <circle cx="32" cy="32" fill="#00D8AF" r="32" />
              <path
                d="M21.5,62.2C4.8,56.5-4,38.2,1.8,21.5S25.8-4,42.5,1.8"
                fill="#00A888"
              />
            </g>
          </svg>
        </Icon>
      ) : (
        <img alt="User Profile" onError={() => setImageError(true)} src={src} />
      )}
    </figure>
  );
});
